import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import playCarouselIcon from '../Images/playCarousel.svg';
import pauseCarouselIcon from '../Images/pauseCarousel.svg';
import leftArrow from '../Images/leftArrow.svg';
import './CarouselNavigation.scss';
import leftArrowHover from '../Images/leftArrowHover.svg';
import leftArrowPressed from '../Images/leftArrowPressed.svg';
import rightArrow from '../Images/rightArrow.svg';
import rightArrowHover from '../Images/rightArrowHover.svg';
import rightArrowPressed from '../Images/rightArrowPressed.svg';

const CarouselNavigation = ({ isPlaying, onToggleAutoplay, onPrev, onNext, style , hasCards}) => (
    <>
        <button className="carousel-arrow carousel-arrow-right" onClick={onPrev} aria-label="הקודם">
            <Image className="icon-default" src={rightArrow} alt="הקודם" />
            <Image className="icon-hover" src={rightArrowHover} alt="" aria-hidden="true" />
            <Image className="icon-pressed" src={rightArrowPressed} alt="" aria-hidden="true" />
        </button>
        <button className="carousel-arrow carousel-arrow-left" onClick={onNext} aria-label="הבא">
            <Image className="icon-default" src={leftArrow} alt="הבא" />
            <Image className="icon-hover" src={leftArrowHover} alt="" aria-hidden="true" />
            <Image className="icon-pressed" src={leftArrowPressed} alt="" aria-hidden="true" />
        </button>
        <div className={`carousel-navigation ${hasCards ? 'has-cards' : ''}`}>
            <button
                className="carousel-play-pause"
                onClick={onToggleAutoplay}
                aria-label={isPlaying ? 'Pause carousel' : 'Play carousel'}
            >
                <Image src={isPlaying ? pauseCarouselIcon : playCarouselIcon} alt={isPlaying ? 'Pause' : 'Play'} />
            </button>

            <div className="carousel-pager swiper-pagination" />
        </div>
    </>
);

export default CarouselNavigation;
